import React, { useState } from 'react';
import { Button, Typography } from '@mui/material';
import errorHandler from 'common/services/errorHandler';
import { useTranslation } from 'services/localization';
import { fetchOnboardingUrl } from '../../utils';
import Spinner from 'common/components/Spinner';
import * as NotificationActions from 'actions/NotificationActions';
import { useDispatch } from 'react-redux';

interface Props {
	accountHolderCode: string;
	text: string;
	variant?: 'textPrimary' | 'textSecondary';
}

export const PaymentOnboardButton = (props: Props) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const [onboardingState, setOnboardingState] = useState<'initial' | 'loading'>('initial');
	const loading = onboardingState === 'loading';

	const adyenOnboarding = async () => {
		setOnboardingState('loading');
		try {
			const { hopUrl } = await fetchOnboardingUrl(props.accountHolderCode);
			setOnboardingState('initial');
			window.location.href = hopUrl;
		} catch (e) {
			dispatch(
				NotificationActions.showNotification({
					variant: 'error',
					message: t('common:errors.error'),
				}),
			);
			setOnboardingState('initial');
			errorHandler.report(e);
		}
	};

	return props.variant === 'textSecondary' ? (
		<Typography
			variant="caption"
			color="secondary"
			onClick={adyenOnboarding}
			sx={{ cursor: 'pointer', ':hover': { textDecoration: 'underline' } }}
		>
			{loading ? (
				<Spinner size={24} padding={6} relative thickness={4} color="inherit" />
			) : (
				props.text
			)}
		</Typography>
	) : (
		<Button
			variant="text"
			size="small"
			disableRipple
			disableFocusRipple
			onClick={adyenOnboarding}
			disabled={loading}
		>
			{loading ? <Spinner padding={8} thickness={4} /> : props.text}
		</Button>
	);
};
